import React from "react";
import {
  Button,
  CTA,
  Text,
  Heading,
  useResponsive,
  Panel,
} from "@clearabee/ui-library-native";
import { Anchor } from "components/Core/Anchor/Anchor";
import { useAnalytics } from "lib/hooks/useAnalytics";
import { useTranslation } from "react-i18next";
import { Image } from "components/Image/Image";
import manVan from "lib/images/van.png";
import { styles, ids } from "./ManVanCard.styles";
import { Platform } from "react-native";

export const ManVanCard = (): React.ReactElement => {
  const [translate] = useTranslation();
  const { ecommerce } = useAnalytics();
  const { screens } = useResponsive();
  const analyticData = {
    item_list_name: "MANVAN Product List",
    item_list_id: "MANVAN_product_list",
  };

  return (
    <Anchor
      routeName="ServicePage"
      params={{ categorySku: "MANVAN" }}
      styles={{ flex: 1 }}
      onClick={() => {
        ecommerce.selectItem(
          {
            sku: "MANVAN",
            title: "Man & Van",
          },
          analyticData.item_list_name,
          analyticData.item_list_id,
        );
      }}
    >
      {screens.small && (
        <CTA
          orientation="portrait"
          heading={
            <Heading
              level={4}
              styles={styles.CTAHeading}
              dataSet={{ media: ids.CTAHeading }}
            >
              {translate("hwa.screens.selectProduct.gotLightWaste")}
            </Heading>
          }
          textColor="brand"
          shadow={Platform.OS === "web"}
          image={
            <Image
              source={manVan}
              resizeMode="contain"
              style={styles.CTAImage}
            />
          }
          background="light"
          styles={styles.manVan}
        >
          <Button color="warning" size="medium" styles={styles.button}>
            <Text
              fontSize="small"
              numberOfLines={1}
              styles={{ fontFamily: "ProximaSemiBold" }}
            >
              {translate("hwa.screens.selectProduct.tryManVan")}
            </Text>
          </Button>
        </CTA>
      )}
      {!screens.small && (
        <Panel
          styles={styles.manVanPanel}
          dataSet={{ media: ids.manVanPanel }}
          shadow={Platform.OS === "web"}
        >
          <Image
            style={styles.manVanImage}
            resizeMode="contain"
            source={manVan}
          />
          <Heading
            level={4}
            styles={styles.manVanHeading}
            dataSet={{ media: ids.manVanHeading }}
          >
            {translate("hwa.screens.selectProduct.gotLightWaste")}
          </Heading>
        </Panel>
      )}
    </Anchor>
  );
};
